



































import HeadService from '~/services/HeadService'
import Breadcrumbs from '~/components/car/Breadcrumbs.vue'
import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import Facets from '~/components/shared/quick-search/facets/Facets.vue'
import { CategoryId } from '~/models/category/types'
import {
  QUICK_SEARCH_NS,
  QuickSearchState
} from '~/store/modules/shared/quickSearch/state'
import { useNamespacedStore } from '~/compositions/store'
import RecentSearchesSelect from '~/components/shared/quick-search/RecentSearchesSelect.vue'
import TopContainer from '~/components/shared/quick-search/TopContainer.vue'
import { Config } from '~/models/quick-search/types'
import { SET_CONFIG } from '~/store/modules/shared/quickSearch/mutation-types'
import QuickSearchItem from '~/components/shared/quick-search/QuickSearchItem.vue'
import QuickSearchContainer from '~/components/shared/quick-search/QuickSearchContainer.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { ciTimes } from '~/icons/source/regular/times'

export default defineComponent({
  components: {
    QuickSearchContainer,
    QuickSearchItem,
    TopContainer,
    Breadcrumbs,
    RecentSearchesSelect,
    Facets
  },
  middleware({ redirect, store }) {
    const isPc = store.getters[`${USER_AGENT_NS}/isPc`]
    if (isPc) {
      redirect('/quick-search/rentals')
    }
  },
  async asyncData({ store, $s }: any) {
    const config: Config = {
      baseUrl: '/api/rentals/quick-search/',
      rootCategoryId: CategoryId.RENTALS,
      facetsCols: {
        pickup_location: 3,
        category: 2,
        rental_period: 4
      },
      backgroundImagesUrls: [
        $s('/nuxt-static/img/quick-search/aggelies-enoikiasewn-mobile.png')
      ]
    }
    store.commit(`${QUICK_SEARCH_NS}/${SET_CONFIG}`, config)
    await Promise.all([
      store.dispatch(`${QUICK_SEARCH_NS}/loadData`),
      store.dispatch(`${QUICK_SEARCH_NS}/loadCategoriesData`)
    ])
  },
  setup() {
    const { state } = useNamespacedStore<QuickSearchState>(QUICK_SEARCH_NS)

    const icons = {
      close: ciTimes
    }

    const breadcrumbs = computed(() => state.breadcrumbs)
    const quickSearches = computed(() => state.quickSearches)

    const store = useStore()
    const isPc = computed(() => store.getters[`${USER_AGENT_NS}/isPc`])

    return { breadcrumbs, quickSearches, isPc, icons }
  },
  head() {
    return this.$dep(HeadService).createHead({
      title: `${this.$t('vehicle rentals')} - ${this.$t('search')}`
    })
  }
})
